<template>
  <validationProvider
    rules="required|max:400"
    v-slot="{ errors, valid }"
    immediate
    name="自己紹介"
  >
    <p>
      <FormTitleText :titleText="$t('profile.selfIntroduction')" />
      <FormAttentionText :attentionText="$t('profile.max400')" />
    </p>
    <v-textarea
      v-model="inputedSelfIntroduction"
      :placeholder="selfIntroductionLabel"
      outlined
      background-color="white"
      counter
      :success="valid"
    ></v-textarea>
    <FormErrorText :errorText="errors[0]" />
  </validationProvider>
</template>

<script>
import FormTitleText from '../Atoms/FormTitleText';
import FormErrorText from '../Atoms/FormErrorText';
import FormAttentionText from '../Atoms/FormAttentionText';
import mypageText from '@/data/mypage/mypageText';

export default {
  name: 'SelfIntroductionForm',
  data: () => ({
    selfIntroductionLabel: mypageText.selfIntroductionLabel,
  }),
  props: ['value'],
  mounted() {
  },
  computed: {
    inputedSelfIntroduction: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
  },
  methods: {
  },
  components: {
    FormTitleText,
    FormErrorText,
    FormAttentionText
  }
};
</script>

<style lang="scss" scoped>
</style>
